import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useState } from 'react'
import { useAuthFetch } from "../api/authFetch";
import UserSelectDialog from '../components/UserSelectDialog';
import LinearProgress from '@mui/material/LinearProgress';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export default function DataGridDemo() {



    const [loading, setLoading] = useState(false);

    const authFetch = useAuthFetch();
    const [consentizerId, setConsentizerId] = useState('');
    const [b2bWebSiteConfigId, setB2BWebSiteConfigId] = useState('');
    const [scenarioConsentizerId, setScenarioConsentizerId] = useState('');
    const [scenarioId, setScenarioId] = useState('');
    const [savedMessage, setSavedMessage] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(false);


    const changeConsentizerId = (event: { target: { value: React.SetStateAction<string>; }; }) => {
      setConsentizerId(event.target.value)
    }


    const changeB2bWebSiteConfigId = (event: { target: { value: React.SetStateAction<string>; }; }) => {
      setB2BWebSiteConfigId(event.target.value)
    }

    const changeScenarioConsentizerId = (event: { target: { value: React.SetStateAction<string>; }; }) => {
      setScenarioConsentizerId(event.target.value)
    }

    const changeScenarioId = (event: { target: { value: React.SetStateAction<string>; }; }) => {
      setScenarioId(event.target.value)
    }

    const userSelected = (selectedItem: string) => {
      // Handle the selected item
      if (selectedItem !== '')
        setConsentizerId(selectedItem);
    };

    const scenarioUserSelected = (selectedItem: string) => {
      // Handle the selected item for scenario
      if (selectedItem !== '')
        setScenarioConsentizerId(selectedItem);
    };

    const savedMessageClose = () => {
      setSavedMessage(false);
    }

    const errorMessageClose = () => {
      setErrorMessage(false);
    }


    const buttonHandler = async() => {


        if (consentizerId === '' &&  b2bWebSiteConfigId === '') return;

        setLoading(true);

        const saveData = {
          consentizerId: consentizerId,
          role: "admin"
        }


        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(saveData)
          };
        const response = await authFetch(process.env.REACT_APP_B2BWEBSITECONFI_URL+"/"+encodeURIComponent(b2bWebSiteConfigId)+"/itempermission"	, requestOptions);

        setLoading(false);
        if (response.ok)
          setSavedMessage(true);
        else
          setErrorMessage(true);
    };

    const scenarioButtonHandler = async() => {


        if (scenarioConsentizerId === '' &&  scenarioId === '') return;

        setLoading(true);

        const saveData = {
          consentizerId: scenarioConsentizerId,
          role: "admin"
        }


        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(saveData)
          };
        const response = await authFetch(process.env.REACT_APP_SCENARIO_URL+"/"+encodeURIComponent(scenarioId)+"/itempermission"	, requestOptions);

        setLoading(false);
        if (response.ok)
          setSavedMessage(true);
        else
          setErrorMessage(true);
    };


   
  return (
    <Box sx={{ height: `auto`, width: '100%' }}>
        <Box
            component="form"
            sx={{
            '& .MuiTextField-root': { m: 1, width: '1000' },
            }}
            noValidate
            autoComplete="off"
          >
                <div  style={{
                    display: 'flex',
                    alignItems: 'center'
                }}>
                <TextField label="ConsentizerId" id="txtConsentizerId" required value={consentizerId} onChange={changeConsentizerId} inputProps={{ style: { width: "300px" }}}
                   />
                <UserSelectDialog
                  onItemSelected={userSelected}
                />

                <TextField label="B2B WebSite Config Id" id="b2bWebSiteConfigId" required value={b2bWebSiteConfigId} onChange={changeB2bWebSiteConfigId} inputProps={{ style: { width: "200px" }}}
                   />

                <Button variant="contained" onClick={buttonHandler}>Share</Button>
            </div>

            {/* Scenario Section */}
            <div  style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '20px'
            }}>
            <TextField label="Scenario ConsentizerId" id="txtScenarioConsentizerId" required value={scenarioConsentizerId} onChange={changeScenarioConsentizerId} inputProps={{ style: { width: "300px" }}}
               />
            <UserSelectDialog
              onItemSelected={scenarioUserSelected}
            />

            <TextField label="Scenario Id" id="scenarioId" required value={scenarioId} onChange={changeScenarioId} inputProps={{ style: { width: "200px" }}}
               />

            <Button variant="contained" onClick={scenarioButtonHandler}>Share Scenario</Button>
        </div>

            <Box sx={{ width: '100%' }}>
                { loading ?
                  <LinearProgress key='waitingStatus'  />
                : null}
            </Box>
        </Box>


      <Snackbar
        open={savedMessage}
        autoHideDuration={8000}
        onClose={savedMessageClose}
        >
          <Alert severity="success" sx={{ width: '100%' }}>
            Data shared.
          </Alert>
      </Snackbar>

      <Snackbar
        open={errorMessage}
        autoHideDuration={8000}
        onClose={errorMessageClose}
        >
          <Alert severity="error" sx={{ width: '100%' }}>
            Data NOT shared.
          </Alert>
      </Snackbar>
    </Box>
  );
}